export default __webpack_public_path__ + "static/media/tech-support.dcd457cf.svg";